// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.IncrementButton-incrementDecrementButton-RsVHb {
	width: 100%;
	border: 1px solid var(--primary-border);
	border-radius: 2px;
	overflow: hidden;
	height: 58px;
	display: grid;
	grid-template-columns: 1fr auto auto;
}

.IncrementButton-incrementDecrementText-au3xY {
	white-space: nowrap;
	overflow: hidden;
	text-overflow: ellipsis;
	padding: 20px 20px 17px;
	margin: 0px;
	font-size: 16px;
	line-height: 1;
	vertical-align: middle;
	font-weight: normal;
	background: var(--primary-input-bg);
}

.IncrementButton-iconButton-_Rnaz {
	border-color: var(--primary-border) !important;
	border-width: 0px 0px 0px 1px;
	border-radius: 0px;
	padding: 12px 21px;
	height: 58px;
	margin: 0;
	font-size: 20px;
	line-height: 1px;
	color: var(--secondary-bg) !important;
	background-color: var(--primary-input-bg) !important;
	-webkit-box-shadow: none;
	        box-shadow: none;
}

.IncrementButton-iconButton-_Rnaz:hover,
.IncrementButton-iconButton-_Rnaz:focus,
.IncrementButton-iconButton-_Rnaz:active {
	background-color: var(--primary-input-bg) !important;
	border-color: var(--primary-border) !important;
	border-width: 0px 0px 0px 1px;
	outline: 0 !important;
	-webkit-box-shadow: none;
	        box-shadow: none;
}

.IncrementButton-circleLayout-udBrC {
	display: -webkit-box;
	display: -ms-flexbox;
	display: flex;
	-webkit-box-align: center;
	    -ms-flex-align: center;
	        align-items: center;
	gap: 12px;
	-ms-flex-wrap: nowrap;
	    flex-wrap: nowrap;
	min-width: 0;
}

.IncrementButton-circleValue-wKUvw {
	font-size: 32px;
	font-weight: bold;
	color: var(--secondary-oscuro);
	min-width: 28px;
	text-align: center;
	line-height: 1;
	margin: 0;
	-ms-flex-negative: 0;
	    flex-shrink: 0;
}

.IncrementButton-circleLabel-eZOgN {
	font-size: 32px;
	font-weight: normal;
	color: var(--secondary-oscuro);
	font-family: var(--font-family-base);
	white-space: nowrap;
	-ms-flex-negative: 0;
	    flex-shrink: 0;
	margin: 0;
}

.IncrementButton-circleButton-VHi_3,
.IncrementButton-circleButton-VHi_3:hover,
.IncrementButton-circleButton-VHi_3:focus,
.IncrementButton-circleButton-VHi_3:active {
	border: 4px solid var(--secondary-oscuro) !important;
	border-radius: 50%;
	width: 44px;
	height: 44px;
	padding: 0;
	background: transparent !important;
	color: var(--secondary-oscuro) !important;
	display: -webkit-box;
	display: -ms-flexbox;
	display: flex;
	-webkit-box-align: center;
	    -ms-flex-align: center;
	        align-items: center;
	-webkit-box-pack: center;
	    -ms-flex-pack: center;
	        justify-content: center;
	-ms-flex-negative: 0;
	    flex-shrink: 0;
	-webkit-box-shadow: none;
	        box-shadow: none;
	outline: 0 !important;
}

.IncrementButton-circleButton-VHi_3:disabled,
.IncrementButton-circleButton-VHi_3:disabled:hover,
.IncrementButton-circleButton-VHi_3:disabled:focus {
	opacity: 0.4;
	cursor: default;
}`, "",{"version":3,"sources":["webpack://./src/components/IncrementButton/IncrementButton.css"],"names":[],"mappings":"AAAA;CACC,WAAW;CACX,uCAAuC;CACvC,kBAAkB;CAClB,gBAAgB;CAChB,YAAY;CACZ,aAAa;CACb,oCAAoC;AACrC;;AAEA;CACC,mBAAmB;CACnB,gBAAgB;CAChB,uBAAuB;CACvB,uBAAuB;CACvB,WAAW;CACX,eAAe;CACf,cAAc;CACd,sBAAsB;CACtB,mBAAmB;CACnB,mCAAmC;AACpC;;AAEA;CACC,8CAA8C;CAC9C,6BAA6B;CAC7B,kBAAkB;CAClB,kBAAkB;CAClB,YAAY;CACZ,SAAS;CACT,eAAe;CACf,gBAAgB;CAChB,qCAAqC;CACrC,oDAAoD;CACpD,wBAAgB;SAAhB,gBAAgB;AACjB;;AAEA;;;CAGC,oDAAoD;CACpD,8CAA8C;CAC9C,6BAA6B;CAC7B,qBAAqB;CACrB,wBAAgB;SAAhB,gBAAgB;AACjB;;AAEA;CACC,oBAAa;CAAb,oBAAa;CAAb,aAAa;CACb,yBAAmB;KAAnB,sBAAmB;SAAnB,mBAAmB;CACnB,SAAS;CACT,qBAAiB;KAAjB,iBAAiB;CACjB,YAAY;AACb;;AAEA;CACC,eAAe;CACf,iBAAiB;CACjB,8BAA8B;CAC9B,eAAe;CACf,kBAAkB;CAClB,cAAc;CACd,SAAS;CACT,oBAAc;KAAd,cAAc;AACf;;AAEA;CACC,eAAe;CACf,mBAAmB;CACnB,8BAA8B;CAC9B,oCAAoC;CACpC,mBAAmB;CACnB,oBAAc;KAAd,cAAc;CACd,SAAS;AACV;;AAEA;;;;CAIC,oDAAoD;CACpD,kBAAkB;CAClB,WAAW;CACX,YAAY;CACZ,UAAU;CACV,kCAAkC;CAClC,yCAAyC;CACzC,oBAAa;CAAb,oBAAa;CAAb,aAAa;CACb,yBAAmB;KAAnB,sBAAmB;SAAnB,mBAAmB;CACnB,wBAAuB;KAAvB,qBAAuB;SAAvB,uBAAuB;CACvB,oBAAc;KAAd,cAAc;CACd,wBAAgB;SAAhB,gBAAgB;CAChB,qBAAqB;AACtB;;AAEA;;;CAGC,YAAY;CACZ,eAAe;AAChB","sourcesContent":[".incrementDecrementButton {\n\twidth: 100%;\n\tborder: 1px solid var(--primary-border);\n\tborder-radius: 2px;\n\toverflow: hidden;\n\theight: 58px;\n\tdisplay: grid;\n\tgrid-template-columns: 1fr auto auto;\n}\n\n.incrementDecrementText {\n\twhite-space: nowrap;\n\toverflow: hidden;\n\ttext-overflow: ellipsis;\n\tpadding: 20px 20px 17px;\n\tmargin: 0px;\n\tfont-size: 16px;\n\tline-height: 1;\n\tvertical-align: middle;\n\tfont-weight: normal;\n\tbackground: var(--primary-input-bg);\n}\n\n.iconButton {\n\tborder-color: var(--primary-border) !important;\n\tborder-width: 0px 0px 0px 1px;\n\tborder-radius: 0px;\n\tpadding: 12px 21px;\n\theight: 58px;\n\tmargin: 0;\n\tfont-size: 20px;\n\tline-height: 1px;\n\tcolor: var(--secondary-bg) !important;\n\tbackground-color: var(--primary-input-bg) !important;\n\tbox-shadow: none;\n}\n\n.iconButton:hover,\n.iconButton:focus,\n.iconButton:active {\n\tbackground-color: var(--primary-input-bg) !important;\n\tborder-color: var(--primary-border) !important;\n\tborder-width: 0px 0px 0px 1px;\n\toutline: 0 !important;\n\tbox-shadow: none;\n}\n\n.circleLayout {\n\tdisplay: flex;\n\talign-items: center;\n\tgap: 12px;\n\tflex-wrap: nowrap;\n\tmin-width: 0;\n}\n\n.circleValue {\n\tfont-size: 32px;\n\tfont-weight: bold;\n\tcolor: var(--secondary-oscuro);\n\tmin-width: 28px;\n\ttext-align: center;\n\tline-height: 1;\n\tmargin: 0;\n\tflex-shrink: 0;\n}\n\n.circleLabel {\n\tfont-size: 32px;\n\tfont-weight: normal;\n\tcolor: var(--secondary-oscuro);\n\tfont-family: var(--font-family-base);\n\twhite-space: nowrap;\n\tflex-shrink: 0;\n\tmargin: 0;\n}\n\n.circleButton,\n.circleButton:hover,\n.circleButton:focus,\n.circleButton:active {\n\tborder: 4px solid var(--secondary-oscuro) !important;\n\tborder-radius: 50%;\n\twidth: 44px;\n\theight: 44px;\n\tpadding: 0;\n\tbackground: transparent !important;\n\tcolor: var(--secondary-oscuro) !important;\n\tdisplay: flex;\n\talign-items: center;\n\tjustify-content: center;\n\tflex-shrink: 0;\n\tbox-shadow: none;\n\toutline: 0 !important;\n}\n\n.circleButton:disabled,\n.circleButton:disabled:hover,\n.circleButton:disabled:focus {\n\topacity: 0.4;\n\tcursor: default;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"incrementDecrementButton": `IncrementButton-incrementDecrementButton-RsVHb`,
	"incrementDecrementText": `IncrementButton-incrementDecrementText-au3xY`,
	"iconButton": `IncrementButton-iconButton-_Rnaz`,
	"circleLayout": `IncrementButton-circleLayout-udBrC`,
	"circleValue": `IncrementButton-circleValue-wKUvw`,
	"circleLabel": `IncrementButton-circleLabel-eZOgN`,
	"circleButton": `IncrementButton-circleButton-VHi_3`
};
module.exports = ___CSS_LOADER_EXPORT___;
